// src/components/dashboard/DashboardCard.js
// Generic widget card (title/icon header + loading/empty states) used by
// every role-specific dashboard widget so they all look consistent.
import React from 'react';
import { Card } from 'react-bootstrap';

function DashboardCard({ title, icon, loading, isEmpty, emptyMessage = 'Nothing to show', className = '', children }) {
  return (
    <Card className={`h-100 shadow-sm ${className}`}>
      <Card.Header className="d-flex align-items-center gap-2 bg-white">
        {icon && <i className={`bi ${icon}`}></i>}
        <span className="fw-semibold">{title}</span>
      </Card.Header>
      <Card.Body>
        {loading ? (
          <div className="text-center text-muted py-3">Loading…</div>
        ) : isEmpty ? (
          <div className="text-center text-muted py-3">{emptyMessage}</div>
        ) : (
          children
        )}
      </Card.Body>
    </Card>
  );
}

export default DashboardCard;
